export const vegetableCurrySoup = {
  id: "vegetableCurrySoup",
  link: "/#/recipes/recipes/vegetableCurrySoup",
  name: "Vegetable Curry Soup",
  cuisine: "Alethi Women's Food",
  summary: "A sweet coconut curry, served as a soup",
  inspiration: "Thai yellow curry",
  quantity: "4 servings",
  time: "30 minutes",
  notes:
    "Most curries I'm familiar with are served with rice or flatbread. I chose to eat it as a soup because of the way it was described in the book, but you could definitely eat it over rice.",
  quotes:
    "...she settled down on the ground and started to spoon herself up a thin, watery curry with vegetables. (Oathbringer ch 13)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/curry-soup-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "sweetPotato",
          display: "1 sweet potato (purple preferred)"
        },
        {
          item: "bellPepper",
          display: "1 red or orange bell pepper"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "garlicClove",
          display: "4 cloves garlic"
        },
        {
          item: "ginger",
          display: "2 inches ginger"
        },
        {
          item: "curryPaste",
          display: "1 tbsp mild curry paste"
        },
        {
          item: "honey",
          display: "1 tbsp honey"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "coriander",
          display: "1/4 tsp ground coriander"
        },
        {
          item: "turmeric",
          display: "1/4 tsp ground turmeric"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "coconut",
          display: "4 cups coconut milk"
        },
        {
          item: "avocado",
          display: "1 avocado"
        }
      ]
    }
  ],
  steps: [
    "Peel and chop the sweet potato into 3/4 inch cubes. Chop the bell pepper into similar sized pieces. Set aside.",
    "Melt 1 tbsp coconut oil in a large pan over medium high heat. Dice the onion and add it to the pan. Cook until transparent but not yet browned.",
    "Peel and mince the garlic and ginger. Add them to the pan, then cook and stir 2 minutes more.",
    "Add curry paste, honey, cumin, coriander, turmeric, and salt. Cook and stir until combined.",
    "Add the chopped sweet potato and bell pepper to the pan. Cook and stir until the pepper is tender.",
    "Add the coconut milk. Simmer on medium low, covered, 10 minutes or until sweet potatoes are soft.",
    "Peel and slice the avocado. Ladle the curry into bowls. To each bowl, add 1/4 of the avocado."
  ]
}
